import _ from "lodash";
import React, { useState } from "react";
import classes from "./AddEvidenceModal.scss";
import classNames from "classnames";
import I18nHOC from "UIComponents/I18nHOC";
import Sidebar from "./Sidebar";
import CardContainer from "./CardContainer";
import Footer from "./Footer";
import {
  getActiveTabConfigMemoized,
  getSelectedEvidenceCountMemoized,
  getAddButtonDisabilityStatusMemoized,
} from "./AddEvidenceModalUtils.js";
import { Modal } from "@toddle-edu/ds-web";
import { MODAL_Z_INDEX } from "Constants";

/**--relative-- */
import { modalStyles, updatedModalStyles } from "./AddEvidenceModalStyles";

const AddEvidenceModal = props => {
  const {
    modalWidth,
    modalHeight,
    template,
    curriculumProgramType,
    onRequestClose,
    initialTab,
    styles,
    actionsStyles,
    onClickView,
    parentIdConfig,
    onClickCancel,
    onClickAdd,
    customEvidences,
    initialAppliedFilters,
    selectAllOptionsInitially,
    initiallySelectedEvidence,
    addButtonLabel,
    t,
    isProjectNode,
    isCompactUINeeded,
    projectNodeDetails,
    noFiltersApplicable,
    curriculumProgramId,
  } = props;

  const sidebarLabel = _.get(template, "label", "");
  const evidenceOptions = _.get(template, "evidenceOptions", []);
  const suggestedEvidenceOptions = _.get(
    template,
    "suggestedEvidenceOptions",
    []
  );

  const [activeTab, setActiveTab] = useState(
    initialTab || _.get(_.first(evidenceOptions), "key", "")
  );

  const allOptions = [...evidenceOptions, ...suggestedEvidenceOptions];

  const [selectedCards, changeSelectedCards] = useState(
    initiallySelectedEvidence ?? {}
  );

  const activeTabConfig = getActiveTabConfigMemoized({
    allOptions,
    activeTab,
  });

  const activeTabEvidenceTypes = _.get(activeTabConfig, "evidenceTypes", []);

  const selectedEvidenceCount = getSelectedEvidenceCountMemoized({
    selectedCards,
  });

  const isAddButtonDisabled = getAddButtonDisabilityStatusMemoized({
    initiallySelectedEvidence,
    selectedCards,
  });

  const handleOnClickAdd = () => {
    onClickAdd({ evidences: selectedCards });
    onClickCancel();
  };

  const showSidebar = _.size(allOptions) > 1;

  const containerClass = classNames(
    {
      [classes.container]: true,
    },
    {
      [classes.noSidebarContainer]: !showSidebar,
    }
  );

  return (
    <Modal
      width={modalWidth}
      height={modalHeight}
      isOpen
      onClose={onRequestClose}
      zIndex={MODAL_Z_INDEX}
      dsVersion={isCompactUINeeded ? "2.0" : "1.0"}
    >
      <Modal.Header
        isClosable
        title={t(`common:${sidebarLabel}`)}
        hasSeparator
        dsVersion={isCompactUINeeded ? "2.0" : "1.0"}
      />
      <Modal.Body
        style={isCompactUINeeded ? updatedModalStyles : modalStyles}
        isScrollable={false}
        dsVersion={isCompactUINeeded ? "2.0" : "1.0"}
      >
        <div className={containerClass}>
          {showSidebar ? (
            <Sidebar
              suggestedEvidenceOptions={suggestedEvidenceOptions}
              evidenceOptions={evidenceOptions}
              activeTab={activeTab}
              selectedCards={selectedCards}
              updateActiveTab={setActiveTab}
              t={t}
            />
          ) : null}
          <div className={classes.rightPane}>
            <CardContainer
              activeTabConfig={activeTabConfig}
              activeTab={activeTab}
              selectedCards={selectedCards}
              changeSelectedCards={changeSelectedCards}
              activeTabEvidenceTypes={activeTabEvidenceTypes}
              parentIdConfig={parentIdConfig}
              onClickView={onClickView}
              styles={styles}
              actionsStyles={actionsStyles}
              customEvidences={customEvidences}
              selectAllOptionsInitially={selectAllOptionsInitially}
              initialAppliedFilters={initialAppliedFilters}
              curriculumProgramType={curriculumProgramType}
              t={t}
              isProjectNode={isProjectNode}
              isCompactUINeeded={isCompactUINeeded}
              projectNodeDetails={projectNodeDetails}
              noFiltersApplicable={noFiltersApplicable}
              curriculumProgramId={curriculumProgramId}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer hasSeparator dsVersion={isCompactUINeeded ? "2.0" : "1.0"}>
        <Footer
          onClickCancel={onClickCancel}
          onClickAdd={handleOnClickAdd}
          isAddButtonDisabled={isAddButtonDisabled}
          selectedEvidenceCount={selectedEvidenceCount}
          addButtonLabel={addButtonLabel}
          t={t}
          isCompactUINeeded={isCompactUINeeded}
          cancelButtonSize={isCompactUINeeded ? "medium" : "large"}
          addButtonSize={isCompactUINeeded ? "medium" : "large"}
        />
      </Modal.Footer>
    </Modal>
  );
};

AddEvidenceModal.defaultProps = {
  initiallySelectedEvidence: {},
  addButtonLabel: null,
  modalWidth: "calc(100vw - 132px)",
  modalHeight: "calc(100vh - 64px)",
};

export default I18nHOC({
  resource: ["common", "snp", "progressReport", "schoolSetup"],
})(AddEvidenceModal);
